import { DefaultTableTypeAbstract } from "./DefaultTableTypeAbstract";

export class DefaultTableTypeFast extends DefaultTableTypeAbstract {
}
